import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IllustrationImagePipe } from '@libs/shared/ui/illustration-image/illustration-image.pipe';

export const IllustrationImageName = {
  Alert: 'alert',
  Annotation: 'annotation',
  CheckingBoxes: 'checking_boxes',
  Connection: 'connection',
  Dashboard: 'dashboard',
  LandscapePhotographer: 'landscape_photographer',
  Loading: 'loading',
  Maintenance: 'maintenance',
  NoData: 'no_data',
  Notify: 'notify',
  OnlineConnect: 'online_connect',
  OptimizeImage: 'optimize_image',
  PageNotFound: 'page_not_found',
  RealTimeCollaboration: 'real_time_collaboration',
  SpeedTest: 'speed_test',
  Towing: 'towing',
  VisualData: 'visual_data',
  Void: 'void',
  Warning: 'warning',
  Welcome: 'welcome',
  Winners: 'winners',
  PersonalTraining: 'personal_training',
  StreetFood: 'street_food',
  SweetHome: 'sweet_home',
} as const;

export type IllustrationImageName =
  (typeof IllustrationImageName)[keyof typeof IllustrationImageName];

@Component({
  selector: 'app-illustration-image',
  standalone: true,
  imports: [CommonModule, IllustrationImagePipe],
  template: `
    <img
      [ngClass]="{
        'h-24': size === 'sm',
        'h-40': size === 'md',
        'h-56': size === 'lg',
        'h-64': size === 'xl',
      }"
      [src]="imageName | illustrationImage"
      alt="illustration Image" />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IllustrationImageComponent {
  @Input({ required: true }) imageName: IllustrationImageName;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
}
